export const url = 'http://localhost:8080/v1/';

export const endpoint = {
    token: 'get_token',
    ship: 'shp/',
};
